import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import { getIsCurrentUserAdminState } from '$/store/profile/selectors';
import TopNav, { ITopNavProps } from './TopNav';
import { doSearchAction, clearSearchAction } from '$/store/search/actions';
import { SearchTypes } from '$/store/search/types';
import * as Bixby from '$/core';

interface ITopNavContainer extends ITopNavProps {
  dispatchDoSearch: (text: string, type: SearchTypes, ap?: boolean) => Promise<void>;
  settings?: Bixby.Models.Settings;
  invertColors?: boolean;
  helpEmail?: string;
}

const TopNavContainer: React.FC<ITopNavContainer> = props => {
  const { dispatchDoSearch, onAdminPortal, settings } = props;

  const handleSearch = async (text: string) => {
    await dispatchDoSearch(text, 'company', onAdminPortal);
  };
  const feedbackUrl = settings ? settings.feedbackUrl : undefined;
  const contactUsLink = settings ? settings.contactUrl : undefined;
  return <TopNav {...props} onSearchChange={handleSearch} feedbackUrl={feedbackUrl} contactUsLink={contactUsLink} />;
};

function mapDispatchToProps(dispatch: any) {
  return {
    dispatchDoSearch: (text: string, type: SearchTypes, ap?: boolean) => dispatch(doSearchAction(text, type, ap)),
    onSearchResultsClick: () => dispatch(clearSearchAction()),
  };
}

function mapStateToProps(state: AppState) {
  const { isAdmin } = getIsCurrentUserAdminState(state);
  const onAdminPortal = window.location.pathname.indexOf('/admin') > -1;
  const searchResults = state.searchState.globalResults;
  const settings = state.settingsState.settings;
  return {
    showAdminLink: isAdmin && !onAdminPortal,
    onAdminPortal: isAdmin && onAdminPortal,
    searchResults,
    settings,
    featureFlags: state.loginState.featureFlags,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TopNavContainer);
